// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"2a7486c0","753":"4963febf","877":"ebd148b8"}[chunkId] + ".chunk.js";
};